<div class="p-g-12 p-dataView-tecfolk-fix pettyCashPage">
   <div class="p-g">
      <div class="p-g-12">
         <div class="card card-w-title">
            <h1>{{setLabel("pettyCashLabel")}}</h1>
            <div class="pettyCashStat">
              <div class="addExpenseMain">
               <div class="pettyCashCurrentBalance">
                  <label>{{setLabel("currentBalance")}}</label>
                  <label>{{user.pettyCash | number: '1.0-0'}}</label>
               </div>
               <div>
               </div>
               <div class="pettyCashActionBtn">
                  <button class="p-button-success" pButton
                     (click)="showAddExpensePopup()">{{setLabel("addExpenseLabel")}}</button>
               </div>
              </div>
            <div class="addExpenseFilterMain">
               <div class="filterFields">
                  <span class="fieldTitle">{{setLabel("fromLabel")}}</span>
                  <p-calendar class="p-calendar-from" [yearNavigator]="true" yearRange="1950:2040"
                     [monthNavigator]="true" [(ngModel)]="from" [placeholder]='setLabel("fromDatePlaceholderLabel")'
                     [inputStyle]="{'color':'#000000'}" name="joinDate" [inline]="false" dateFormat="dd/mm/yy"
                     [showIcon]="true" (onSelect)="getUserPettyExpenses()">
                  </p-calendar>
               </div>
               <div class="filterFields">
                  <span class="fieldTitle">{{setLabel("toLabel")}}</span>
                  <p-calendar class="p-calendar-to" [yearNavigator]="true" yearRange="1950:2040" [monthNavigator]="true"
                     [(ngModel)]="to" [placeholder]='setLabel("toDatePlaceholderLabel")'
                     [inputStyle]="{'color':'#000000'}" name="joinDate" [inline]="false" dateFormat="dd/mm/yy"
                     [showIcon]="true" (onSelect)="getUserPettyExpenses()">
                  </p-calendar>
               </div>
               <div *ngIf="user.role === 'Admin' || user.role === 'Super Admin'" class="filterFields">
                  <span class="fieldTitle" for="">{{setLabel("selectUserLabel")}}</span>
                  <p-dropdown
                  class="p-inputtext"
                  [options]="accountHolderOptions"
                  name="selectPackage"
                  [style]="{'width':'100%','background':'none'}"
                  required
                  [(ngModel)]="optionValue"
                  (onChange)="onChangeHolderValue()" >
                  </p-dropdown>
              </div>
            </div>
            <div class="exportPettyExpenseButton"  *ngIf="pettyExpenses && pettyExpenses.length > 0"
               [pTooltip]='setLabel("exportTooltipLabel")' tooltipPosition="top" [disabled]="loading" [disabled]="!isData"
               (click)="ExportData(pettyExpenses, 'PettyExpense_Report')">
               <i class="fa fa-download"></i>
            </div>
            </div>
            <div class="pettyCashTable">
               <p-table [value]="pettyExpenses" [loading]="loading"
                  class="feeTable hideTabileHeadOnMobile p-table-tecfolk-fix">
                  <ng-template pTemplate="header">
                     <tr>
                        <th>{{setLabel("amountLabel")}}</th>
                        <th>{{setLabel("expenseTypeLabel")}}</th>
                        <th>{{setLabel("dateLabel")}}</th>
                        <th>{{setLabel("detailsLabel")}}</th>
                        <th>{{setLabel("createdOnLabel")}}</th>
                        <th>{{setLabel("commentLabel")}}</th>
                        <th>{{setLabel("actionLabel")}}</th>
                     </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-pe>
                     <tr>
                        <td>
                           <span class="hideonMobile">{{setLabel("amountLabel")}}</span>
                           {{pe.amount | number: '1.0-0'}}</td>
                        <td>
                           <span class="hideonMobile">{{setLabel("expenseTypeLabel")}}</span>
                           {{pe.type}}</td>
                        <td>
                           <span class="hideonMobile">{{setLabel("dateLabel")}}</span>
                           {{pe.date | date:'dd/MM/yyyy'}}</td>
                        <td>
                           <span class="hideonMobile">{{setLabel("detailsLabel")}}</span>
                           {{getDetailOfExpance(pe)}}</td>
                        <td>
                           <span class="hideonMobile">{{setLabel("createdOnLabel")}}</span>
                           {{pe.createdDate | date:'dd/MM/yyyy'}}</td>
                        <td>
                           <span class="hideonMobile">{{setLabel("commentLabel")}}</span>
                           {{pe.description}}</td>
                        <td>
                           <button *ngIf="pe.type === 'Lending' && !pe.isReturned" pButton class="p-button-success"
                              (click)="updatePettyExpense(pe._id)">{{setLabel("amountReturnedLabel")}}</button>
                        </td>

                     </tr>
                  </ng-template>
               </p-table>
            </div>
         </div>
      </div>
   </div>
</div>
<!-- <div *ngIf="pettyExpenseDialogVisibility" class="tecfolkProfileDialogFix">
   <p-dialog [header]='setLabel("addPettyExpenseHeaderLabel")' [(visible)]="pettyExpenseDialogVisibility">
      <div class="pettyExpensePopup">
         <div class="pettyExpenseTpe">
            <label>{{setLabel("paymentModeLabel")}}</label>
            <p-dropdown [options]="paymentOptions" (onChange)="onPaymentModeChange($event.value)"></p-dropdown>
         </div>
         <div class="pettyExpenseAmount">
            <label>{{setLabel("amountLabel")}}</label>
            <input type="number" min="0" pInputText name="pettyExpenseAmount" [(ngModel)]="amount" />
         </div>

         <div class="pettyExpenseTpe">
            <label>{{setLabel("expenseTypeLabel")}}</label>
            <select style="width: 14em; height: 2em;" pInputText type="text" [(ngModel)]="expenseType">
               <option value="Purchasing">{{setLabel("purchasingLabel")}}</option>
               <option value="Lending">{{setLabel("lendingLabel")}}</option>
               <option value="Bills">{{setLabel("billsLabel")}}</option>
               <option value="Account Deducted">{{setLabel("accountDeductedLabel")}}</option>
            </select>
         </div>
         <div *ngIf="expenseType === 'Lending'" class="pettyExpenseTpe">
            <Label>{{setLabel("borrowerNameLabel")}}</Label>
            <p-dropdown name="Borrower Name" style="width: 14em; height: 2em;" [options]="userOptions"
               [(ngModel)]="selectedUser"  (onChange)="dropdownChange($event)">
            </p-dropdown>
         </div>
         <div *ngIf="expenseType === 'Account Deducted'" class="pettyExpenseTpe">
            <Label>{{setLabel("accountHolderNameLabel")}}</Label>
            <p-dropdown name="Account Holder Name" style="width: 14em; height: 2em;" [options]="usersOptions"
               [(ngModel)]="selectedUser"  (onChange)="dropdownChange($event)">
            </p-dropdown>
         </div>
         <div *ngIf="expenseType === 'Purchasing'" class="pettyExpenseTpe">
            <Label>{{setLabel("productNameLabel")}}</Label>
            <select style="width: 14em; height: 2em;" type="text" pInputText name="Purchased Item"
               [(ngModel)]="purchasedItem">
               <optgroup label="Foods">
                  <option value="Pizza">{{setLabel("pizzaLabel")}}</option>
                  <option value="Burger">{{setLabel("burgerLabel")}}</option>
                  <option value="Pasta">{{setLabel("pastaLabel")}}</option>
                  <option value="Biryani">{{setLabel("biryaniLabel")}}</option>
                  <option value="Pulao">{{setLabel("pulaoLabel")}}</option>
                  <option value="Desi Food">{{setLabel("desiFoodLabel")}}</option>
               </optgroup>
               <optgroup label="Tea">
                  <option value="Coffee">{{setLabel("coffeeLabel")}}</option>
                  <option value="Green Tea">{{setLabel("greenTeaLabel")}}</option>
                  <option value="Tea">{{setLabel("teaLabel")}}</option>
               </optgroup>
               <optgroup label="Drinks">
                  <option value="Minarl Water">{{setLabel("mineralWaterLabel")}}</option>
                  <option value="Juice">{{setLabel("juiceLabel")}}</option>
                  <option value="Cold Drinks">{{setLabel("coldDrinksLabel")}}</option>
                  <option value="Energy Drinks">{{setLabel("energyDrinksLabel")}}</option>
               </optgroup>
               <optgroup label="Others">
                  <option value="Air freshner">{{setLabel("airFreshnerLabel")}}</option>
                  <option value="Print Paper">{{setLabel("printPaperLabel")}}</option>
                  <option value="Equipment Part">{{setLabel("equipmentPartLabel")}}</option>
               </optgroup>
            </select>
         </div>
         <div *ngIf="expenseType === 'Bills'" class="pettyExpenseTpe">

            <Label>{{setLabel("billTypeLabel")}}</Label>
            <select style="width: 14em; height: 2em;" type="text" pInputText name="Bill Type" [(ngModel)]="billType">
               <option value="Electricity">{{setLabel("electricityLabel")}}</option>
               <option value="Internet">{{setLabel("internetLabel")}}</option>
               <option value="Maintenance">{{setLabel("maintenanceLabel")}}</option>
               <option value="Repairing">{{setLabel("repairingLabel")}}</option>
               <option value="Water Bottles">{{setLabel("waterBottlesLabel")}}</option>
               <option value="Other">{{setLabel("otherLabel")}}</option>
            </select>
         </div>

         <div class="pettyExpenseTpe">
            <div style="justify-content: space-between;" class="p-inputgroup">
               <span>{{setLabel("commentLabel")}}</span>
               <textarea style="width: 59% !important; border: 1px solid darkgray;" rows="5" cols="50"
                  [(ngModel)]="description" name="description" pInputTextarea></textarea>
            </div>
         </div>
         <div class="pettyExpenseBtn">
            <button class="p-button-success" pButton
               (click)="addPettyExpense()">{{setLabel("addExpenseLabel")}}</button>
         </div>
      </div>
   </p-dialog>
</div> -->

<div *ngIf="pettyExpenseDialogVisibility" class="tecGym-component">
   <app-pettycashdialouge (closePettyCashDialog)="closePettyCashDialog()"
      [pettydialogVisibility]="pettyExpenseDialogVisibility"></app-pettycashdialouge>
</div>